import React, { ChangeEvent } from 'react'
import apiRest from '../../../services/apiRest'
import { addSnackbar } from '../../../store/snacks/snacksActions'

// material-ui
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'

// types
interface Props {
  categories: any[]
  churchId: string
  state: any
  setOpenModalTithing: any
  dispatch: any
  setState: any
  filters: any
  openModalTithing: boolean
  onChangeFilterState: any
  category: any
  matches: boolean
}
type PropsEvent = ChangeEvent<{ value: unknown }>
type PropsPrintType = 'Extrato' | 'Relatório'

export const ResumeAccumulated = ({
  setOpenModalTithing,
  churchId,
  state,
  dispatch,
  setState,
  filters,
  openModalTithing,
  onChangeFilterState,
  category,
  matches,
}: Props) => {
  const onClickTithing = async () => {
    if (state.type === 'all') {
      dispatch(
        addSnackbar('Selecione uma categoria', {
          variant: 'error',
        })
      )
      return
    }

    const popup = window.open('', '_blank')
    if (popup) {
      if (!matches) {
        popup.document.write('arquivo baixado verifique o download')
      } else {
        popup.document.write('Aguarde...')
      }
      const { data } = await apiRest.get('/tithing', {
        responseType: 'arraybuffer',
        params: {
          churchId,
          dateFrom: state.dateFrom,
          dateTo: state.dateTo,
          category: state.category,
          type: state.type,
        },
      })
      const pdfURL = URL.createObjectURL(
        new Blob([data], { type: 'application/pdf' })
      )
      popup.location.href = pdfURL

      if (!matches) {
        // corrigir erro no android
        var fileLink = document.createElement('a')
        fileLink.href = pdfURL
        fileLink.download = 'pdf_name'
        fileLink.click()
        popup.document.write('arquivo baixado verifique o download')
      } else {
        setTimeout(() => {
          popup.print()
          URL.revokeObjectURL(pdfURL)
        }, 500)
      }
    }

    setOpenModalTithing(false)
  }

  return (
    <>
      <Dialog
        onClose={() => {
          setOpenModalTithing(false)
          setTimeout(() => {
            setState({
              dateFrom: filters.dateFrom,
              dateTo: filters.dateTo,
              type: filters.type,
              resource: filters.resource,
              category: filters.category,
            })
          }, 200)
        }}
        open={openModalTithing}
      >
        <DialogTitle>Relatório acumulado</DialogTitle>
        <DialogContent>
          <TextField
            type="date"
            label="Data inicial"
            value={state.dateFrom}
            onChange={onChangeFilterState('dateFrom')}
          />
          <TextField
            type="date"
            label="Data final"
            value={state.dateTo}
            onChange={onChangeFilterState('dateTo')}
          />
          {state.type === 'incomes' || state.type === 'expenses' ? (
            <FormControl
              component="fieldset"
              style={{ marginTop: 16, marginLeft: 25 }}
            >
              <Select
                value={state.category}
                onChange={onChangeFilterState('category')}
                placeholder="Name"
                displayEmpty
              >
                <MenuItem disabled value={'all'}>
                  Selecione categoria
                </MenuItem>
                {category.map((item: any) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 16,
            }}
          >
            <FormControl component="fieldset" style={{ marginTop: 16 }}>
              <FormLabel component="legend">Tipo</FormLabel>
              <RadioGroup
                row
                value={state.type}
                onChange={onChangeFilterState('type')}
              >
                <FormControlLabel
                  value="incomes"
                  control={<Radio color="primary" />}
                  label="Receitas"
                />
                <FormControlLabel
                  value="expenses"
                  control={<Radio color="primary" />}
                  label="Despesas"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenModalTithing(false)
              setTimeout(() => {
                setState({
                  dateFrom: filters.dateFrom,
                  dateTo: filters.dateTo,
                  type: filters.type,
                  resource: filters.resource,
                  category: filters.category,
                })
              }, 200)
            }}
          >
            Cancelar
          </Button>
          <Button onClick={onClickTithing} color="primary">
            Imprimir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
